import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'Statistics' })({
    tooltip: {
        background: '#fff',
        boxShadow: '0px 10px 40px 0px rgba(176, 178, 186, 0.20)',
        borderRadius: 16,
        padding: 16
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        gap: 16
    },
    chart: {
        position: 'relative',
        borderRadius: 8,
        background: '#FAFAFA'
    },
    spinner: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%'
    },
    blur: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backdropFilter: 'blur(6px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    signIn: {
        padding: '14px 16px',
        borderRadius: 12,
        fontSize: 16,
        fontWeight: 500,
        lineHeight: '16px',
        color: '#fff',
        boxShadow: 'none !important',
        background: '#282D31',
        '&:hover': {
            background: '#4D4D4D'
        },
        '&:focus': {
            background: '#4D4D4D'
        },
        '&:active': {
            background: '#000000'
        }
    }
});
